import * as Panel2 from '../panel';
import {inputType} from './common';

import ConfigComponent from './ConfigComponent';
import Component from './Component';

export const Spec: Panel2.PanelSpec = {
  id: 'histogram',
  ConfigComponent,
  Component,
  inputType,
  canFullscreen: true,
};
